// components/PageShell.jsx
import React from "react";
import { Box, Chip, Container, Stack, Typography } from "@mui/material";
import HeroBanner from "./HeroBanner";
import { getIconEl } from "./utils";

/**
 * Standard page wrapper that optionally shows a HeroBanner.
 * Props: { title, children, chips, bannerImage, contentSx }
 */
export default function PageShell({ title, children, chips, bannerImage, contentSx }) {
  return (
    <Container sx={{ py: { xs: 2, sm: 3, md: 5 } }}>
      {bannerImage ? (
        <HeroBanner
          title={title}
          image={bannerImage}
          height={300}
          chips={chips}
          backgroundPosition={title === "Standings" ? "top" : "center"}
        />
      ) : (
        <Stack spacing={2} sx={{ mb: 2.5, pt: { xs: 1, md: 2 } }}>
          <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap">
            {getIconEl("SportsMotorsports", { fontSize: "medium" })}
            <Typography variant="h4" component="h1" sx={{ fontSize: { xs: "2rem", sm: "2.5rem" } }}>
              {title}
            </Typography>
            {chips?.map((c) => (
              <Chip key={c} label={c} size="small" color="primary" variant="outlined" />)
            )}
          </Stack>
        </Stack>
      )}

      <Box
        sx={{
          p: { xs: 1, sm: 2, md: 3 },
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          borderRadius: { xs: 1.5, md: 2.5 },
          overflow: "hidden",
          ...contentSx,
        }}
      >
        {children}
      </Box>
    </Container>
  );
}
